const CANCEL_BUTTON = "action-button-cancel";
const SAVE_BUTTON = "action-button-save";
export {
  CANCEL_BUTTON,
  SAVE_BUTTON
};
//# sourceMappingURL=data-hooks.js.map
